export default __webpack_public_path__ + "static/ab-screen-2-mobile-63088d0357c25fa61ef8a56952a65b3b.jpg";